/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLongestPath = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="m16.586 4-1.293-1.293 1.414-1.414L20.414 5l-3.707 3.707-1.414-1.414L16.586 6H7a3 3 0 0 0 0 6h7.682a6.03 6.03 0 0 0-1.88 2H7A5 5 0 0 1 7 4zm-1.904 18a6.03 6.03 0 0 1-1.88-2H5v2zM14 17a4 4 0 1 1 8 0 4 4 0 0 1-8 0zm3.5.208 1.146 1.146.707-.707-.853-.854V15h-1z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgLongestPath as LongestPath };
